import moment from 'moment';
import React from 'react';

const OIModelHeading = ({   puttCallvalue, props }) => {
  return (
    <div>
      <h2 style={{ marginBottom: 0, marginLeft: '5%' }}>
        {props.ticker} {props.expiration} ${props.modalRowData.strike}{' '}
        {props.type === 'stockPage'
          ? puttCallvalue
          : props.modalRowData.put_call}
      </h2>
      <div style={{ color: '#A0A0A1', marginLeft: '5%' }}>
        {moment(props.selectedDate).format('MMM DD YYYY')}
      </div>
    </div>
  );
};

export default OIModelHeading;



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/components/OIModelHeading.jsx